/**
 * /erp/dispatches — Dispatch shell (Manager+ for PR-F).
 *
 * The router gates the section to manager+ via the API; sales-scoping
 * for the read surface lands in PR-G. The shell is intentionally thin
 * — it only renders an Outlet so the list / "new" / detail pages keep
 * their own headers and breadcrumbs (the detail page especially
 * benefits from showing the dispatch code in the heading rather than
 * a generic "Dispatch").
 */

import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/erp/dispatches")({
  component: DispatchShell,
});

function DispatchShell() {
  return <Outlet />;
}
